// import React from "react";
// import { Container, Grid, Typography, Box, Card, Avatar } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import { styled } from "@mui/material/styles";
// import Header from "./Header"; // Common Header Component
// import Footer from "./Footer"; // Common Footer Component

// // Importing Images
// import heroBg from "../assets/heroBg.jpeg";
// import heroBg1 from "../assets/heroBg1.jpeg";
// import image from "../assets/image.png";
// import image2 from "../assets/image2.png.jpg";

// // Services Data
// const services = [
//   { title: "Custom Software", img: heroBg },
//   { title: "AI & Automation", img: heroBg1 },
//   { title: "AR/VR Applications", img: image },
//   { title: "UI/UX Design", img: image2 },
// ];

// // Testimonials Data
// const testimonials = [
//   {
//     name: "John Doe",
//     feedback:
//       "Willovate transformed our business with a cutting-edge AI system!",
//     img: "/assets/user1.jpg",
//   },
//   {
//     name: "Emily Smith",
//     feedback:
//       "The team delivered a custom web app that exceeded our expectations!",
//     img: "/assets/user2.jpg",
//   },
// ];

// // Styled Button
// const GradientButton = styled("button")({
//   marginTop: "20px",
//   padding: "12px 30px",
//   fontSize: "1.2rem",
//   fontWeight: "bold",
//   color: "#fff",
//   background: "linear-gradient(90deg, #84F4EE, #2DEB9C)",
//   border: "none",
//   borderRadius: "30px",
//   cursor: "pointer",
//   transition: "transform 0.3s ease, box-shadow 0.3s ease",
//   "&:hover": {
//     transform: "scale(1.05)",
//     boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
//   },
// });

// const ExploreMore = () => {
//   const navigate = useNavigate();

//   return (
//     <Box>

//       <Header /> {/* Common Header Component */}

//       {/* Hero Section with Background Image */}
//       <Box
//         sx={{
//           position: "relative",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           height: { xs: "220px", md: "100px" },
//           textAlign: "center",
//           overflow: "hidden",
//           mt: { xs: 7, md: 8 },
//         }}
//       >
//         {/* Background Image */}
//         <Box
//           sx={{
//             position: "absolute",
//             top: 0,
//             left: 0,
//             transform: "translate(-50%, -50%)",
//             width: "100%",
//             height: "100%",
//             backgroundSize: "cover",
//             backgroundPosition: "center",
//             backgroundRepeat: "no-repeat",
//             filter: "brightness(50%)",
//             zIndex: -1,
//           }}
//         />

//         {/* Text Content */}
//         <Typography
//           variant="h2"
//           fontWeight="bold"
//           sx={{ color: "#000ca4", zIndex: 1 }}
//         >
//           AI Automation
//         </Typography>
//       </Box>

//       {/* Services Section */}
//       <Container
//         width="100%" maxWidth="100%"
//         sx={{ textAlign: "center", backgroundColor: "#fff", py: 10}}
//       >
//         <Grid container spacing={4} justifyContent="center" alignItems="stretch">
//           {services.map((item, index) => (

//             <Grid item xs={12} sm={6} md={3} key={index}>

//               <Box
//                 sx={{
//                   width: "100%",
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   backgroundColor: "#fff",
//                   borderRadius: "12px",
//                   boxShadow: "0 4px 12px rgba(45, 92, 235, 0.58)",
//                   textAlign: "center",
//                   transition: "0.3s",
//                   height: "100%",
//                   border: "1px solid #e0e0e0",
//                   minHeight: "340px", // Adjust card height
//                   "&:hover": {
//                     transform: "scale(1.05)",
//                     boxShadow: "0 6px 18px rgb(45, 235, 156, 0.9)",
//                     border: "1px solid #2DEB9C",
//                   },
//                 }}
//               >

//                 {/* Image Box with Centered Title */}
//                 <Box
//                   sx={{
//                     position: "relative",
//                     textAlign: "center",
//                     width: "100%",
//                   }}
//                 >

//                   <Box
//                     component="img"
//                     src={item.img}
//                     alt={item.title}
//                     sx={{
//                       width: "100%",
//                       height: "200px",
//                       objectFit: "cover",
//                       borderRadius: "10px 10px 0 0",
//                     }}
//                   />

//                   <Typography
//                     variant="h5"
//                     fontWeight="600"
//                     sx={{
//                       width: "100%",
//                       maxWidth:"400px",
//                       mt: 5,
//                       px: 0,
//                       mb: 2,
//                       color: "#333",
//                       textAlign: "center",
//                       fontFamily: "Poppins, sans-serif",
//                     }}
//                   >
//                     {item.title}
//                   </Typography>

//                 </Box>

//               </Box>

//             </Grid>

//           ))}
//         </Grid>
//       </Container>

//       {/* Testimonials Section */}
//       <Box
//         sx={{
//           background:
//             "linear-gradient(to right, rgba(45, 92, 235, 1), rgb(45, 235, 156))",
//           py: 12,
//         }}
//       >

//         <Container maxWidth="lg">
//           <Typography
//             variant="h3"
//             fontWeight="bold"
//             textAlign="center"
//             mb={5}
//             sx={{ color: "#fff" }}
//           >
//             What Our Clients Say
//           </Typography>

//           <Grid container spacing={4} justifyContent="center">
//             {testimonials.map((client, index) => (
//               <Grid item xs={12} sm={6} md={4} key={index}>

//                 <Card
//                   sx={{
//                     padding: "30px",
//                     textAlign: "center",
//                     borderRadius: "10px",
//                     boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
//                   }}
//                 >

//                   <Avatar
//                     src={client.img}
//                     sx={{ width: 80, height: 80, margin: "auto" }}
//                   />

//                   <Typography variant="h5" fontWeight="bold" mt={2} mb={2}>
//                     {client.name}
//                   </Typography>

//                   <Typography variant="body2" color="textSecondary">
//                     "{client.feedback}"
//                   </Typography>

//                 </Card>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* Call to Action */}
//       <Box sx={{ textAlign: "center", backgroundColor: "#fff", py: 18 }}>

//         <Typography variant="h2" fontWeight="bold" color="black"mb={5}  >
//           Have an idea? Let’s build it together!
//         </Typography>

//         <GradientButton onClick={() => navigate("/contact")}>
//           Start Your Project
//         </GradientButton>

//       </Box>

//       <Footer /> {/* Common Footer Component */}

//     </Box>
//   );
// };

// export default ExploreMore;

import React from "react";
import {
  Container,
  Grid,
  Typography,
  Box,
  Card,
  Avatar,
  Button,
  Chip,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";

// Icons
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import SettingsInputComponentIcon from "@mui/icons-material/SettingsInputComponent";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import DataObjectIcon from "@mui/icons-material/DataObject";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

// Images
// import aiHero from "../assets/ai-hero.jpg";
// import mlImage from "../assets/ml-image.jpg";
// import automationImage from "../assets/automation.jpg";
// import chatbotImage from "../assets/chatbot.jpg";
// import predictionImage from "../assets/prediction.jpg";

import heroBg from "../assets/heroBg.jpeg";
import heroBg1 from "../assets/heroBg1.jpeg";
import image from "../assets/image.png";
import image2 from "../assets/image2.png.jpg";

// Styled Components
const GlowButton = styled(Button)(({ theme }) => ({
  background: "linear-gradient(90deg, #2D5CEB 0%, #2DEB9C 100%)",
  color: "white",
  borderRadius: "30px",
  padding: "12px 32px",
  fontWeight: "600",
  textTransform: "none",
  fontSize: "1.05rem",
  boxShadow: "0 6px 16px rgba(45, 235, 156, 0.25)",
  transition: "all 0.3s ease",
  "&:hover": {
    transform: "translateY(-3px)",
    boxShadow: "0 12px 30px rgba(45, 235, 156, 0.4)",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "10px 24px",
    fontSize: "1rem",
  },
}));

const FeatureCard = styled(Card)(({ theme }) => ({
  height: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-between",
  padding: theme.spacing(4),
  borderRadius: "16px",
  background: "rgba(255, 255, 255, 0.05)",
  backdropFilter: "blur(10px)",
  border: "1px solid rgba(45, 235, 156, 0.2)",
  transition: "all 0.3s ease",
  "&:hover": {
    transform: "translateY(-8px)",
    boxShadow: "0 15px 30px rgba(45, 235, 156, 0.15)",
    borderColor: "rgba(45, 235, 156, 0.5)",
  },
}));

const Discover = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const solutions = [
    {
      title: "Machine Learning",
      icon: (
        <SettingsInputComponentIcon
          color="primary"
          sx={{ fontSize: 50, color: "#2D5CEB" }}
        />
      ),
      description: "Custom algorithms that learn and improve from experience",
      image: heroBg1,
    },
    {
      title: "Process Automation",
      icon: (
        <PrecisionManufacturingIcon
          color="primary"
          sx={{ fontSize: 50, color: "#2D5CEB" }}
        />
      ),
      description: "Eliminate repetitive tasks with intelligent automation",
      image: heroBg,
    },
    {
      title: "AI Chatbots",
      icon: (
        <DataObjectIcon
          color="primary"
          sx={{ fontSize: 50, color: "#2D5CEB" }}
        />
      ),
      description:
        "24/7 conversational agents with natural language processing",
      image: image2,
    },
    {
      title: "Predictive Analytics",
      icon: (
        <AutoAwesomeIcon
          color="primary"
          sx={{ fontSize: 50, color: "#2D5CEB" }}
        />
      ),
      description: "Forecast trends and behaviors with advanced modeling",
      image: image,
    },
  ];

  const benefits = [
    "40-60% cost reduction in operations",
    "90%+ accuracy in decision making",
    "24/7 automated customer support",
    "Real-time data processing",
    "Scalable AI infrastructure",
  ];

  return (
    <Box sx={{ overflowX: "hidden" }}>
      {/* Hero Section */}
      <Box
        sx={{
          background: `linear-gradient(rgba(0, 12, 164, 0.85), rgba(0, 12, 164, 0.85)), url(${image2})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "#ffff",
          py: isMobile ? 8 : 14,
          textAlign: "center",
          mt: { xs: 7, md: 4.4 },
          minHeight: isMobile ? "60vh" : "55vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mb: 3,
        }}
      >
        <Container width="100%" maxWidth="lg">
          <Chip
            label="THE FUTURE IS NOW"
            color="primary"
            sx={{
              mb: 3,
              color: "#2DEB9C",
              fontWeight: "bold",
              background: "rgba(45, 235, 156, 0.2)",
              border: "1px solid #2DEB9C",
            }}
          />
          <Typography
            variant={isMobile ? "h4" : "h2"}
            fontWeight="bold"
            gutterBottom
          >
            Transform Your Business With{" "}
            <span style={{ color: "#2DEB9C" }}>AI Automation</span>
          </Typography>
          <Typography variant="h6" sx={{ maxWidth: 800, mx: "auto", mb: 4 }}>
            We build intelligent systems that learn, adapt, and automate -
            delivering unprecedented efficiency and insights
          </Typography>
          <GlowButton onClick={() => navigate("/contact")}>
            Unlock AI Potential
          </GlowButton>
        </Container>
      </Box>

      {/* Solutions Section */}
      <Container sx={{ py: 10 }}>
        <Typography
          variant="h3"
          fontWeight="bold"
          textAlign="center"
          color="#000ca4"
          mb={2}
        >
          AI Solutions We Engineer
        </Typography>
        <Typography
          variant="body1"
          textAlign="center"
          sx={{ mb: 6, maxWidth: 700, mx: "auto", color: "text.secondary" }}
        >
          Custom-built artificial intelligence tailored to your specific
          business needs
        </Typography>

        <Grid container spacing={4} sx={{ mb: 10, display: "flex"}}>
          {solutions.map((solution, index) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={3}
              key={index}
              sx={{ display: "flex" }}
            >
              <FeatureCard
                sx={{
                  flex: 1,
                  background: "white",
                  boxShadow: "0 4px 20px rgba(0, 12, 164, 0.1)",
                  border: "1px solid rgba(0, 12, 164, 0.1)",
                  "&:hover": {
                    boxShadow: "0 8px 30px rgba(0, 12, 164, 0.15)",
                  },
                }}
              >
                <Box
                  sx={{
                    width: 80,
                    height: 80,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "rgba(45, 92, 235, 0.1)",
                    borderRadius: "50%",
                    mb: 2,
                  }}
                >
                  {solution.icon}
                </Box>
                <Typography
                  variant="h5"
                  fontWeight="bold"
                  textAlign="center"
                  mt={1}
                >
                  {solution.title}
                </Typography>
                <Typography
                  variant="body2"
                  textAlign="center"
                  sx={{ mt: 0, mb: 1, color: "text.secondary" }}
                >
                  {solution.description}
                </Typography>
                <Box
                  component="img"
                  src={solution.image}
                  alt={solution.title}
                  sx={{
                    width: "100%",
                    height: 180,
                    objectFit: "cover",
                    borderRadius: "8px",
                  }}
                />
              </FeatureCard>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Benefits Section */}
      <Box
        sx={{
          background: "linear-gradient(135deg, #2D5CEB 0%, #2DEB9C 100%)",
          py: 10,
          color: "white",
        }}
      >
        <Container>
          <Typography
            variant="h3"
            fontWeight="bold"
            align="center"
            sx={{ mb: 7 }}
          >
            Why Choose Our AI Solutions?
          </Typography>

          <Grid container spacing={4} justifyContent="center">
            {benefits.map((benefit, index) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                key={index}
                sx={{ display: "flex" }}
              >
                <Card
                  sx={{
                    p: 3,
                    background: "hsla(0, 0.00%, 100.00%, 0.2)",
                    backdropFilter: "blur(5px)",
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    borderRadius: "12px",
                    flex: 1,
                    display: "flex",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <CheckCircleIcon
                      sx={{ color: "#2DEB9C", mr: 1, fontSize: 31 }}
                    />
                    <Typography variant="h6" fontWeight="500">
                      {benefit}
                    </Typography>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* CTA Section */}
      <Box
        sx={{
          background: "#f9fbfe",
          py: 10,
          textAlign: "center",
        }}
      >
        <Container maxWidth="md">
          <Typography
            variant="h3"
            fontWeight="bold"
            sx={{ color: "#000ca4", mb: 4 }}
          >
            Ready to Automate Your Future?
          </Typography>
          <Typography
            variant="h6"
            sx={{ mb: 5, maxWidth: 700, mx: "auto", color: "black" }}
          >
            Our AI specialists will analyze your business and propose the
            perfect automation strategy
          </Typography>
          <GlowButton onClick={() => navigate("/contact")}>
            Get Free AI Audit
          </GlowButton>
        </Container>
      </Box>
    </Box>
  );
};

export default Discover;
